var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EEFDFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7501 9.0835H22.6251C21.2437 9.0835 19.919 9.63223 18.9422 10.609C17.9655 11.5857 17.4167 12.9105 17.4167 14.2918V17.4168H14.2917V21.5835H17.4167V29.9168H21.5834V21.5835H24.7084L25.7501 17.4168H21.5834V14.2918C21.5834 14.0156 21.6932 13.7506 21.8885 13.5553C22.0839 13.3599 22.3488 13.2502 22.6251 13.2502H25.7501V9.0835Z",
    stroke: "#00BF62",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceicon);
export default __webpack_public_path__ + "static/media/faceicon.9a2f64c30ea8f07594491d2a304a63d9.svg";
export { ForwardRef as ReactComponent };